/* global gdAlertify */
import React, { useState, useEffect } from "react";
import axiosInstance from "../config/axiosConfig";
import { Grid, _ } from 'gridjs-react';
import 'gridjs/dist/theme/mermaid.css'
import { gridOptions } from "../utils/gridOptions";
import { calculateAge, formatDate } from "../utils/utils";
import GdTable from "./components/GdTable";
import { render } from "@testing-library/react";

const clasificacionMap = {
    0: '',
    1: 'Básico 0',
    2: 'Básico 0-1',
    3: 'Básico 1',
    4: 'Básico 1-2',
    5: 'Básico 2',
    6: 'Básico 2-3',
    7: 'Básico 3',
    8: 'D',
};

const DetalleAuxiliar = ({ isOpen, onClose, details, observaciones }) => {
    if (!isOpen) return null;
    const columns3 = [
        { name: "observacionID", title: "ID" },
        { name: 'fecha', title: 'Fecha', render: (row) => formatDate(row.fecha) },
        { name: 'observacion', title: 'Observación' }
    ];
    return (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="userDetailsModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="userDetailsModalLabel">Detalles del Usuario</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        {details ? (
                            <div>
                                <p><strong>Nombre Completo:</strong> {details.nombre} {details.apellidoPaterno} {details.apellidoMaterno}</p>
                                <p><strong>Rut:</strong> {details.rut}</p>
                                <p><strong>Sexo:</strong> {details.sexo === "2" ? "Femenino" : "Masculino"}</p>
                                <p><strong>Nacionalidad:</strong> {details.nacionalidad}</p>
                                <p><strong>Estado Civil:</strong> {details.estadoCivil === "casada" ? "Casada" : "Soltera"}</p>
                                <p><strong>Dirección:</strong> {details.direccion}</p>
                                <p><strong>Teléfono Celular:</strong> {details.celular}</p>
                                <p><strong>Email:</strong> {details.email || "No proporcionado"}</p>
                                <p><strong>Institución:</strong> {details.institucion}</p>
                                <p><strong>Título Profesional:</strong> {details.titulo}</p>
                                <p><strong>Fecha de Nacimiento:</strong> {formatDate(details.fechaNacimiento)}</p>
                                <p><strong>Edad:</strong> {calculateAge(details.fechaNacimiento)}</p>
                                <p><strong>Fecha de Ingreso:</strong> {formatDate(details.fechaIngreso)}</p>
                                <p><strong>Comuna:</strong> {details.des_comuna}</p>
                                <p><strong>Observaciones:</strong> {details.observaciones}</p>
                                <h3 className="mt-4">Observaciones</h3>
                                {observaciones ? (
                                    <GdTable
                                        columns={columns3}
                                        data={observaciones}
                                        defaultItemsPerPage={100}
                                        itemsPerPageOptions={[5, 10, 25, 50, 100]}
                                        initialSort={[0, "asc"]}
                                    />
                                ) : (
                                    <p>No hay observaciones registradas</p>
                                )}
                            </div>
                        ) : (
                            <p>Cargando...</p>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

function AuxiliarSearch() {
    // Estado para almacenar las opciones de categorización, turnos y clasificación
    const [categorizaciones, setCategorizaciones] = useState([]);
    const [turnos, setTurnos] = useState([]);
    const [clasificaciones, setClasificaciones] = useState([]);
    const [observacionesAuxiliar, setObservacionesAuxiliar] = useState(null);

    // Estado para almacenar los valores de los filtros y la tabla de resultados
    const [fechaInicio, setFechaInicio] = useState("");
    const [tipoturno, setTipoTurno] = useState("3");
    const [fechaFin, setFechaFin] = useState("");
    const [fechaIngreso, setFechaIngreso] = useState("");
    const [sexo, setSexo] = useState({ femenino: false, masculino: false });
    const [selectedClasificaciones, setSelectedClasificaciones] = useState([]);
    const [selectedCategorizaciones, setSelectedCategorizaciones] = useState([]);
    const [selectedTurnos, setSelectedTurnos] = useState([]);
    const [resultados, setResultados] = useState([]);
    const [sinAcuerdo, setSinAcuerdo] = useState(false);

    // Obtener los datos de Categorizaciones y Turnos al cargar el componente
    useEffect(() => {
        async function fetchData() {
            try {
                gdAlertify.showLoader()
                // Aquí se hacen las peticiones para obtener las categorías y los turnos
                const categorizacionesResponse = await axiosInstance.get("/params/categorias");
                // const turnosResponse = await axiosInstance.get("/params/turnos");
                const clasificacionesResponse = await axiosInstance.get("/params/clasificaciones");
                let categorias = categorizacionesResponse.data.categorias.filter(cat => cat.id != 5 && cat.id != 4);
                setCategorizaciones(categorias);
                // setTurnos(turnosResponse.data.turnos);
                setClasificaciones(clasificacionesResponse.data.clasificaciones);
                gdAlertify.hideLoader()
            } catch (error) {
                console.error("Error al obtener los datos: ", error);
            }
        }

        fetchData();
    }, []);

    // Estados
    const [selectedSexos, setSelectedSexos] = useState([]);

    // Funciones genéricas
    const toggleAll = (items, selectedItems, setSelectedItems) => {
        if (selectedItems.length === items.length) {
            setSelectedItems([]);
        } else {
            setSelectedItems(items.map(item => item.id));
        }
    };

    const toggleItem = (id, selectedItems, setSelectedItems) => {
        if (selectedItems.includes(id)) {
            setSelectedItems(selectedItems.filter(item => item !== id));
        } else {
            setSelectedItems([...selectedItems, id]);
        }
    };

    // Funciones específicas
    const handleAllSexoChange = () => {
        toggleAll([{ id: '1' }, { id: '2' }], selectedSexos, setSelectedSexos);
    };
    const handleSexoChange = (id) => {
        toggleItem(id, selectedSexos, setSelectedSexos);
    };

    const handleAllClasificacionChange = () => {
        toggleAll(clasificaciones, selectedClasificaciones, setSelectedClasificaciones);
    };
    const handleClasificacionChange = (id) => {
        toggleItem(id, selectedClasificaciones, setSelectedClasificaciones);
    };

    const handleAllCategoriaChange = () => {
        toggleAll(categorizaciones, selectedCategorizaciones, setSelectedCategorizaciones);
    };
    const handleCategorizacionChange = (id) => {
        toggleItem(id, selectedCategorizaciones, setSelectedCategorizaciones);
    };

    const handleAllTurnoChange = () => {
        toggleAll(turnos, selectedTurnos, setSelectedTurnos);
    };
    const handleTurnoChange = (id) => {
        toggleItem(id, selectedTurnos, setSelectedTurnos);
    };



    // Función para buscar los resultados con Axios
    const buscarAuxiliares = async () => {

        gdAlertify.showLoader()
        try {
            const params = {
                fechaDisponible: fechaInicio,
                fechaFin,
                fechaIngreso,
                sexo: selectedSexos, // Filtros por sexo
                clasificaciones: selectedClasificaciones,
                categorizaciones: selectedCategorizaciones,
                sinAcuerdo,
                tipoturno,
                categoriaNOTIN: [4,5]
            };
            // Realiza la llamada a la API para obtener los auxiliares
            const response = await axiosInstance.get("/auxiliar/busqueda", { params });

            setResultados(response.data.data); // Almacena los resultados en el estado
            gdAlertify.hideLoader()
        } catch (error) {
            gdAlertify.hideLoader()
            console.error("Error al buscar auxiliares: ", error);
        }
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [detalleAuxiliar, setDetalleAuxiliar] = useState(null);

    const verDetalleAuxiliar = async (idAuxiliar) => {
        setIsModalOpen(true); // Abre el modal
        setDetalleAuxiliar(null); // Limpia los datos previos mientras carga
        setObservacionesAuxiliar(null);

        const params = {
            idAuxiliar: idAuxiliar
        };

        try {
            gdAlertify.showLoader()
            const response = await axiosInstance.get("/auxiliar/busqueda", { params });
            setDetalleAuxiliar(response.data.data[0]);

            const historialResponse = await axiosInstance.get("/auxiliar/historial", { params });
            setObservacionesAuxiliar(historialResponse.data.data.observaciones);
            gdAlertify.hideLoader()
        } catch (error) {
            gdAlertify.hideLoader()
            console.error(error);
            setDetalleAuxiliar({ error: "No se pudo cargar la información" });
        }
    };

    const columns = [
        { name: 'nombre', title: 'Nombre' },
        { name: 'apellidoPaterno', title: 'Apellido Paterno' },
        { name: 'celular', title: 'Celular' },
        { name: 'fechaIngreso', title: 'Fecha Ingreso', render: (row) => formatDate(row.fechaIngreso) },
        { name: 'clasificacionID', title: 'Clasificación', render: (row) => clasificacionMap[row.clasificacionID],cellClassName: "text-center", },
        { name: 'des_categoria', title: 'Categorización',cellClassName: "text-center", },
        {
            name: 'id',
            title: 'Acción',
            render: (row) => {
                return (
                    <button
                        className="btn btn-primary"
                        onClick={() => verDetalleAuxiliar(row.id)} // Captura el ID
                    >
                        Ver Detalle
                    </button>
                )
            },
        }
    ]

    return (
        <div className="container mt-4">
            <div className="card">
                <div className="card-body">
                    <h3 className="mb-4">Búsqueda de Auxiliar</h3>

                    {/* Filtros de búsqueda */}
                    <div className="row g-3">
                        {/* Filtros por fechas */}
                        <div className="col-md-6">
                            <label className="form-label">Fecha Disponible</label>
                            <input
                                type="date"
                                className="form-control"
                                value={fechaInicio}
                                onChange={(e) => setFechaInicio(e.target.value)}
                            />
                        </div>
                        <div className="col-md-6">
                            {fechaInicio && (
                                <>
                                <label className="form-label">Tipo de Turno:</label>
                                <select
                                    className="form-select"
                                    value={tipoturno}
                                    onChange={(e) => setTipoTurno(e.target.value)}
                                >
                                    <option value="3">Día y Noche</option>
                                    <option value="1">Día</option>
                                    <option value="2">Noche</option>
                                </select>
                                </>
                            )}
                        </div>



                        {/* Filtros por sexo */}
                        <div className="col-md-3">
                            <label className="form-label">Sexo</label>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="allSexo"
                                    checked={selectedSexos.length === 2}
                                    onChange={handleAllSexoChange}
                                />
                                <label className="form-check-label" htmlFor="allSexo">
                                    Seleccionar Todos
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="sexo-2"
                                    checked={selectedSexos.includes('2')}
                                    onChange={() => handleSexoChange('2')}
                                />
                                <label className="form-check-label" htmlFor="sexo-2">
                                    Femenino
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="sexo-1"
                                    checked={selectedSexos.includes('1')}
                                    onChange={() => handleSexoChange('1')}
                                />
                                <label className="form-check-label" htmlFor="sexo-1">
                                    Masculino
                                </label>
                            </div>
                        </div>

                        {/* Filtros por clasificación */}
                        <div className="col-md-3">
                            <label className="form-label">Clasificación</label>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="allClasificacion"
                                    checked={selectedClasificaciones.length === clasificaciones.length}
                                    onChange={handleAllClasificacionChange}
                                />
                                <label className="form-check-label" htmlFor="allClasificacion">
                                    Seleccionar Todos
                                </label>
                            </div>
                            {clasificaciones.map((clasificacion) => (
                                <div key={clasificacion.id} className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`clas-${clasificacion.id}`}
                                        checked={selectedClasificaciones.includes(clasificacion.id)}
                                        onChange={() => handleClasificacionChange(clasificacion.id)}
                                    />
                                    <label className="form-check-label" htmlFor={`clas-${clasificacion.id}`}>
                                        {clasificacion.nombre}
                                    </label>
                                </div>
                            ))}
                        </div>

                        {/* Filtros por categorización */}
                        <div className="col-md-3">
                            <label className="form-label">Categorización</label>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="allCategoria"
                                    checked={selectedCategorizaciones.length === categorizaciones.length}
                                    onChange={handleAllCategoriaChange}
                                />
                                <label className="form-check-label" htmlFor="allCategoria">
                                    Seleccionar Todos
                                </label>
                            </div>
                            {categorizaciones.map((categorizacion) => (
                                <div key={categorizacion.id} className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`cat-${categorizacion.id}`}
                                        checked={selectedCategorizaciones.includes(categorizacion.id)}
                                        onChange={() => handleCategorizacionChange(categorizacion.id)}
                                    />
                                    <label className="form-check-label" htmlFor={`cat-${categorizacion.id}`}>
                                        {categorizacion.codigo}
                                    </label>
                                </div>
                            ))}
                        </div>
                        <div className="col-md-3">
                            <div className="form-check mt-2">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="sinAcuerdo"
                                    checked={sinAcuerdo}
                                    onChange={(e) => setSinAcuerdo(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="sinAcuerdo">
                                    Sin acuerdos
                                </label>
                            </div>
                        </div>

                        <div className="col-md-12 d-flex justify-content-center">
                            <button className="btn btn-primary" onClick={buscarAuxiliares}>
                                Buscar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        {/* Tabla de resultados */}
                        <GdTable
                            columns={columns}
                            data={resultados}
                            defaultItemsPerPage={100}
                            itemsPerPageOptions={[5, 10, 25, 50, 100]}
                            initialSort={[0, "asc"]}
                        />
                    </div>
                </div>
            </div>

            {/* Modal */}
            <DetalleAuxiliar
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                details={detalleAuxiliar}
                observaciones={observacionesAuxiliar}
            />

        </div>
    );
}

export default AuxiliarSearch;
